import { URLData } from '@telia-common-components/shared';
import React from 'react';
import API from '../../../util/ApiUtil';
import ErrorUtil from '../../../util/ErrorUtil';
import { FetchStatus } from '../../../util/FetchStatus';
import { internetSuggestSpeedCalculatorDefaultState } from './suggest/InternetSuggestSpeedUtil';
export const InternetCalculatorProvider = (props) => {
    const [auth, setAuth] = React.useState(props.auth);
    const [isSsoLoaded, setIsSsoLoaded] = React.useState(props.isSsoLoaded);
    const [openSsoFrame, setOpenSsoFrame] = React.useState(() => props.openSsoFrame);
    const [onInternetSelect, setOnInternetSelect] = React.useState(() => props.onInternetSelect);
    const [internetCalculatorConfigState, setInternetCalculatorConfigState] = React.useState({
        status: FetchStatus.UNINITIALIZED,
        config: null,
    });
    const [modalState, setModalState] = React.useState({
        showForm: false,
        offer: null,
    });
    const [suggestSpeedState, setSuggestSpeedState] = React.useState(internetSuggestSpeedCalculatorDefaultState);
    const [internetCalculatorExtraCardsState, setInternetCalculatorExtraCardsState] = React.useState({
        status: FetchStatus.UNINITIALIZED,
        extraCards: [],
    });
    const [secureNetCalculatorExtraCardsState, setSecureNetCalculatorExtraCardsState] = React.useState({
        status: FetchStatus.UNINITIALIZED,
        extraCards: [],
    });
    const isSecureNet = props.isSecureNet;
    const urlData = new URLData({ ...props, lang: props.language });
    const offersApi = API(urlData.commonAPIBaseURL, {
        withCredentials: true,
        timeout: 20000,
    });
    React.useEffect(() => {
        setAuth(props.auth);
        setIsSsoLoaded(props.isSsoLoaded);
        setOnInternetSelect(() => props.onInternetSelect);
        setOpenSsoFrame(() => props.openSsoFrame);
    }, [props.auth, props.isSsoLoaded]);
    const fetchInternetCalculatorConfig = async () => {
        try {
            setInternetCalculatorConfigState({
                status: FetchStatus.FETCHING,
                config: null,
            });
            const { data } = await offersApi.get('/internet-offers/calculator-config', {
                params: { isSecureNet },
            });
            setInternetCalculatorConfigState({
                status: FetchStatus.FETCHED,
                config: data,
            });
        }
        catch (e) {
            ErrorUtil.pushErrorToTeliaRumAndLog(e);
            setInternetCalculatorConfigState({
                status: FetchStatus.ERROR,
                config: null,
            });
        }
    };
    const fetchInternetCalculatorExtraCards = async (lang) => {
        try {
            setInternetCalculatorExtraCardsState({
                status: FetchStatus.FETCHING,
                extraCards: [],
            });
            const { data } = await offersApi.get(`/offers/internet-calculator/${lang}`);
            setInternetCalculatorExtraCardsState({
                status: FetchStatus.FETCHED,
                extraCards: data.offers,
            });
        }
        catch (e) {
            ErrorUtil.pushErrorToTeliaRumAndLog(e);
            setInternetCalculatorExtraCardsState({
                status: FetchStatus.ERROR,
                extraCards: [],
            });
        }
    };
    const fetchSecureNetCalculatorExtraCards = async (lang) => {
        try {
            setSecureNetCalculatorExtraCardsState({
                status: FetchStatus.FETCHING,
                extraCards: [],
            });
            const { data } = await offersApi.get(`/offers/secure-net-calculator/${lang}`);
            setSecureNetCalculatorExtraCardsState({
                status: FetchStatus.FETCHED,
                extraCards: data.offers,
            });
        }
        catch (e) {
            ErrorUtil.pushErrorToTeliaRumAndLog(e);
            setSecureNetCalculatorExtraCardsState({
                status: FetchStatus.ERROR,
                extraCards: [],
            });
        }
    };
    return (React.createElement(InternetCalculatorContext.Provider, { value: {
            auth,
            urlData,
            isSsoLoaded,
            isSecureNet,
            openSsoFrame,
            internetCalculatorConfigState,
            secureNetCalculatorExtraCardsState,
            internetCalculatorExtraCardsState,
            fetchInternetCalculatorConfig,
            fetchInternetCalculatorExtraCards,
            fetchSecureNetCalculatorExtraCards,
            suggestSpeedState,
            setSuggestSpeedState,
            modalState,
            setModalState,
            onInternetSelect,
        } }, props.children));
};
const InternetCalculatorContext = React.createContext({
    auth: null,
    urlData: null,
    isSsoLoaded: false,
    isSecureNet: false,
    openSsoFrame: () => undefined,
    internetCalculatorConfigState: undefined,
    secureNetCalculatorExtraCardsState: undefined,
    internetCalculatorExtraCardsState: undefined,
    fetchInternetCalculatorExtraCards: (_lang) => undefined,
    fetchSecureNetCalculatorExtraCards: (_lang) => undefined,
    fetchInternetCalculatorConfig: () => undefined,
    suggestSpeedState: internetSuggestSpeedCalculatorDefaultState,
    setSuggestSpeedState: (_newState) => undefined,
    modalState: { offer: null, showForm: false },
    setModalState: (_modalState) => undefined,
    onInternetSelect: (_val) => undefined,
});
export const useInternetCalculator = () => {
    return React.useContext(InternetCalculatorContext);
};
